export const getMenuListingPath = (
  currentAppId: string,
  isLegacyFlagOn: boolean,
  isLegacyFlagReady: boolean,
  isOrgListingV3On: boolean,
  isOrgListingV3Ready: boolean
): string | null => {
  const isListingV3Enabled = isLegacyFlagOn || isOrgListingV3On;
  // Pending only while neither flag has resolved yet.
  if (!isListingV3Enabled && !isLegacyFlagReady && !isOrgListingV3Ready) {
    return null;
  }
  if (isListingV3Enabled) {
    return `/${currentAppId}/restaurant-menus`;
  }
  return `/${currentAppId}/menu-editor/menus`;
};
